var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindAndReplaceOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90625 2.5C4.92523 2.5 2.5 4.92523 2.5 7.90625C2.5 10.8873 4.92523 13.3125 7.90625 13.3125C10.8873 13.3125 13.3125 10.8873 13.3125 7.90625C13.3125 4.92523 10.8873 2.5 7.90625 2.5ZM7.90625 0C12.2727 0 15.8125 3.53975 15.8125 7.90625C15.8125 12.2727 12.2727 15.8125 7.90625 15.8125C3.53975 15.8125 0 12.2727 0 7.90625C0 3.53975 3.53975 0 7.90625 0Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5635 13.125L18.7505 18.75",
    stroke: "#272D55",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90625 7.34375V11.1687",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90625 5.46875C8.45853 5.46875 8.90625 5.02103 8.90625 4.46875C8.90625 3.91647 8.45853 3.46875 7.90625 3.46875C7.35397 3.46875 6.90625 3.91647 6.90625 4.46875C6.90625 5.02103 7.35397 5.46875 7.90625 5.46875Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindAndReplaceOperationIcon);
export default __webpack_public_path__ + "static/media/FindAndReplaceOperationIcon.a5b3fb82e49feb2cc90d784ad6cbb0d9.svg";
export { ForwardRef as ReactComponent };